import { AdminItemDescriptionType, AdminItemTitleType } from './courses';

import { AdminUploadedImage } from './media';
import { LanguageType } from 'types/languages';

export type AdminParameterPrimaryCategory = 'Tee-to-green' | 'Putting' | 'Biomechanics';

export type AdminParameterCategory = 'Club' | 'Launch' | 'Flight' | 'Roll' | 'Green' | 'Alignment' | 'Rotations' | 'Translations';

export type ParameterMediaType = 'Image' | 'ThreeDModel';

export type ParameterCategoryMap = Record<AdminParameterPrimaryCategory, string[]>;

export const PrimaryCategoryToCategoriesMap: ParameterCategoryMap = {
    "Tee-to-green": ['Club', 'Launch', 'Flight'],
    "Putting": ['Club', 'Launch', 'Roll', 'Green'],
    "Biomechanics": ['Alignment', 'Rotations', 'Translations']
}

export type ParameterLegendModel = {
  legendImageUrl: string;
  legendDescriptions: AdminItemDescriptionType[];
};

export type LegendModelGET = {
  id: string;
  url: string;
  name: string;
};

export type VideoUrlModel = {
  videoUrl: string;
  label: string;
};

export type AdminParameterModel = {
  id?: string;
  titles: AdminItemTitleType[];
  primaryCategory: AdminParameterPrimaryCategory;
  category: AdminParameterCategory;
  mediaType: ParameterMediaType;
  mainImgData?: AdminUploadedImage;
  mainImgUrl?: string;
  legendData: ParameterLegendModel[];
  threeDModelUrl?: string;
  languages: LanguageType[];
  definitions: AdminItemDescriptionType[];
  usageInfo: AdminItemDescriptionType[];
  videoUrls: VideoUrlModel[];
  articlesInfo: AdminItemDescriptionType[];
  visible: boolean;
  averageTourDataVisible: {
    pga: boolean;
    lpga: boolean;
  };
};

export type AdminParameterListItemModel = {
  id: string;
  primaryCategory: string;
  title: string;
  languages: LanguageType[];
  visible: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type AdminParametersList = AdminParameterListItemModel[];
